export default "__VITE_ASSET__BiAcaSfC__"